<template>
  <div class="w-100 b-we b-EDF4FC-H" style="box-shadow: 0px 8px 18px rgba(32, 35, 36, 0.08);" v-inview:animate="'fadeInUp'">
    <!--Button-->
    <div class="w-100 nh-60px">
      <!--Agree-->
      <div class="w-52px h-60px" @click="toggleIsAgree">
        <div class="p-a w-24px h-24px bor-100 c-we t-18px r-8px tn-500ms"
             :class="{'b-D7E1EA': !agreement.is_agreed, 'b-1BAAF1': agreement.is_agreed }"
             style="position: absolute;">
          <img class="cen" src="@/assets/images/agreements/check.svg" alt="arrow-down"/>
        </div>
      </div>
      <!--Title-->
      <div class="w-100_106px f-18px lh-30px pt-15px pb-15px" @click="toggleIsAgree">
        <b>{{agreement.title}}</b>
      </div>
      <!--Arrow-->
      <div class="w-54px h-60px" @click="toggleIsOpen">
        <img class="cen" src="@/assets/images/agreements/arrow-down.svg" alt="arrow-down" v-if="agreement.content"/>
        <img class="cen" src="@/assets/images/agreements/arrow-right.svg" alt="arrow-right" v-else-if="agreement.file"/>
      </div>
    </div>
    <!--Content-->
    <div ref="content" class="h-0px o-0 o-h">
      <div
           class="w-100 bo_t-1 bo-D7E1EA f-14px lh-20px c-727D8C pt-18px pl-18px pr-20px pb-20px tn-500ms o-h"
          style="border-top-width: 1px; float: none;"
          v-if="agreement.content"
          v-html="agreement.content"
        >
        <!-- {{agreement.content}} -->
      </div>
    </div>
  </div>
</template>

<script>
import { gsap, TweenLite, Circ } from 'gsap'
import { CSSPlugin } from 'gsap/CSSPlugin'

gsap.registerPlugin(CSSPlugin)

// import contractsApi from '@/api/now/contractsApi'

export default {
  name: 'AgreementItem',
  components: {},
  props: {
    agreement: {
      type: Object,
      default() { return null }
    },
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  created() {},
  mounted() {},
  destroyed() {},
  computed: {
    isAgree() {
      if (!this.agreement) return false
      return this.agreement.is_agreed
    }
  },
  methods: {
    toggleIsAgree() {
      // Toggle
      this.agreement.is_agreed = !this.agreement.is_agreed
      // Toggle All
      if (this._.get(this.agreement, 'is_all')) {
        this.$emit('toggleAll')
      }
    },
    toggleIsOpen() {
      if (!this._.get(this.agreement, 'uuid')) { return }
      if (this._.get(this.agreement, 'code') === 'SERVICE') {
        this.$router.push({ name: 'terms/service' })
        return
      }
      if (this.agreement.content) {
        this.isOpen = !this.isOpen

        if (this.isOpen) {
          TweenLite.to(this.$refs.content, 0.5, { height: 'auto', opacity: 1, ease: Circ.easeInOut })
        } else {
          TweenLite.to(this.$refs.content, 0.5, { height: 0, opacity: 0, ease: Circ.easeInOut })
        }
      } else if (this.agreement.image || this.agreement.file) {
        this.$router.push({
          name: 'agreements/detail',
          params: {
            agreement: this.agreement
          }
        })
        // this.$emit('openFile', { file: this.agreement.file, image: this.agreement.image })
      }
    }
  }
}
</script>

<style scoped>

</style>
